import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import { Cross } from "../../../shared/assets/icons";
import Modal from "@mui/material/Modal";
import Styles from "../../../styles/vendorDashboard.module.css";
import GlobalButton from "../../../shared/utils/GlobalButton";

const ROLE_MAP = {
  "-1": "Super Admin",
  0: "Admin",
  1: "Business Development",
  2: "Management Trainee",
  3: "Purchase",
  4: "Operations Manager",
  5: "IP Manager",
  6: "Store Onboarding Executive",
  7: "Designer Manager",
};

const UserViewModal = ({ selectedUserData, setUserModalOpen }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImage, setIsImage] = useState(false);

  const handleClose = () => setUserModalOpen(false);

  const handleImageClick = (src) => {
    setSelectedImage(src);
    setIsImage(true);
  };

  const formatDate = (date) => {
    if (!date) return "Not Available";
    return new Date(date).toLocaleDateString();
  };

  const basicInfo = [
    { label: "Name", value: selectedUserData?.name },
    { label: "Email", value: selectedUserData?.email },
    { label: "Phone Number", value: selectedUserData?.phoneNumber },
    { label: "Role", value: ROLE_MAP[selectedUserData?.role] },
    { label: "Experience", value: selectedUserData?.experience },
  ];

  const locationInfo = [
    { label: "Zone", value: selectedUserData?.zone || "Not Available" },
    { label: "State", value: selectedUserData?.state || "Not Available" },
    { label: "City", value: selectedUserData?.city || "Not Available" },
    { label: "Address", value: selectedUserData?.address || "Not Available" },
  ];

  const systemInfo = [
    {
      label: "Account Status",
      value: selectedUserData?.isDeleted ? "Deleted" : "Active",
    },
    {
      label: "Created At",
      value: formatDate(selectedUserData?.createdAt),
    },
  ];

  const renderSection = (title, data) => (
    <div className="bg-white rounded-lg shadow-md p-6 mb-4">
      <h3 className="text-xl font-bold text-gray-600 mb-4">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {data.map((item, idx) => (
          <div key={idx}>
            <span className="font-bold text-gray-600">{item.label}</span>
            <p className="text-gray-600">{item.value || "Not Available"}</p>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <Dialog open={true} onClose={handleClose} fullWidth maxWidth="xl">
      <div className={`flex justify-between ${Styles.vendorModalColor}`}>
        <DialogTitle>User Profile Details</DialogTitle>
        <div onClick={handleClose} className="mx-5 my-4 cursor-pointer">
          <Cross />
        </div>
      </div>

      <DialogContent className={Styles.vendorModalColor}>
        <Box>
          <div className="flex flex-col md:flex-row gap-4">
            {/* Sidebar */}
            <aside className="w-full md:w-1/4">
              <div className="text-center bg-white rounded-lg shadow-md p-6">
                <img
                  src={
                    selectedUserData?.profilePhoto ||
                    "/assests/AdminDashboard/userForIP.webp"
                  }
                  alt="Profile"
                  className="w-24 h-24 rounded-full mx-auto mb-4 cursor-pointer"
                  onClick={() =>
                    handleImageClick(
                      selectedUserData?.profilePhoto ||
                        "/assests/AdminDashboard/userForIP.webp",
                    )
                  }
                />
                <h2 className="text-lg font-semibold">
                  {selectedUserData?.name}
                </h2>
                <p className="text-gray-500">
                  {ROLE_MAP[selectedUserData?.role]}
                </p>
              </div>
            </aside>

            {/* Main content */}
            <main className="w-full md:w-3/4">
              {renderSection("Basic Information", basicInfo)}
              {renderSection("Location Details", locationInfo)}
              {renderSection("System Information", systemInfo)}
            </main>
          </div>
        </Box>
      </DialogContent>

      <DialogActions>
        {" "}
        <div className="w-30">
          <GlobalButton variant="primary" size="medium" onClick={handleClose}>
            {`Close`}
          </GlobalButton>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default UserViewModal;
